import React, { useEffect, useState } from 'react';
import { components } from '~/assets';

const ProductTabs = ({ products = [], onTabChange }) => {
  const [activeTab, setActiveTab] = useState(null);

  const allowedProducts = ['TEUCARD', 'CONVENIO'];
  const availableProducts = products.filter((product) =>
    allowedProducts.includes(product.toUpperCase()),
  );
  const filteredProducts = availableProducts.sort((a, b) => {
    if (a.toUpperCase() === 'TEUCARD') return -1;
    if (b.toUpperCase() === 'TEUCARD') return 1;
    return 0;
  });

  useEffect(() => {
    if (filteredProducts.length > 0 && !activeTab) {
      const firstProduct = filteredProducts[0].toUpperCase();
      setActiveTab(firstProduct);
    }
  }, [filteredProducts, activeTab]);

  const handleTabClick = (product) => {
    const productUpper = product.toUpperCase();
    if (productUpper !== activeTab && onTabChange) {
      setActiveTab(productUpper);
      onTabChange(productUpper);
    }
  };

  const getTabIcon = (product) => {
    const isActive = activeTab === product.toUpperCase();

    const iconStyle = {
      width: '20px',
      height: '20px',
      marginRight: '8px',
    };

    switch (product.toUpperCase()) {
      case 'TEUCARD':
        if (isActive) {
          return <components.TabTeucardRed style={iconStyle} />;
        }
        return <components.TabTeucard style={iconStyle} />;
      case 'CONVENIO':
        if (isActive) {
          return <components.TabConvenioRed style={iconStyle} />;
        }
        return <components.TabConvenio style={iconStyle} />;
      default:
        return null;
    }
  };

  const getTabStyles = (product) => {
    const isActive = activeTab === product.toUpperCase();

    return {
      display: 'flex',
      alignItems: 'center',
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: 500,
      borderBottom: '2px solid',
      borderLeft: 'none',
      borderRight: 'none',
      borderTop: 'none',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      outline: 'none',
      color: isActive ? '#E91E63' : '#666666',
      borderBottomColor: isActive ? '#E91E63' : 'transparent',
    };
  };

  const formatProductName = (product) => {
    switch (product.toUpperCase()) {
      case 'TEUCARD':
        return 'TeuCard';
      case 'CONVENIO':
        return 'Convênio';
      default:
        return product;
    }
  };

  const containerStyle = {
    width: '100%',
    marginBottom: '20px',
  };

  const tabsContainerStyle = {
    display: 'flex',
    borderBottom: '1px solid #E0E0E0',
    backgroundColor: '#FFFFFF',
  };

  return (
    <div style={containerStyle}>
      <div style={tabsContainerStyle}>
        {filteredProducts.map((product) => (
          <button
            key={product}
            style={getTabStyles(product)}
            onClick={() => handleTabClick(product)}
            onMouseEnter={(e) => {
              if (activeTab !== product.toUpperCase()) {
                (e.target as HTMLButtonElement).style.color = '#F06292';
              }
            }}
            onMouseLeave={(e) => {
              if (activeTab !== product.toUpperCase()) {
                (e.target as HTMLButtonElement).style.color = '#666666';
              }
            }}
          >
            {getTabIcon(product)}
            <span>{formatProductName(product)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductTabs;
